import { render, staticRenderFns } from "./UserNotifySettings.vue?vue&type=template&id=bc6c5cb2&"
import script from "./UserNotifySettings.vue?vue&type=script&lang=js&"
export * from "./UserNotifySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports